import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

/**
 * Normalize a phone number to E.164, defaulting to Israel.
 * Accepts "052-631-6979", "0526316979", "+972 52 631 6979", "972526316979", "00972…".
 * Returns null when the input is not a plausible phone number.
 */
export function normalizePhone(input: string | null | undefined): string | null {
  if (!input) return null;
  let raw = String(input).trim();
  if (!raw) return null;
  // Strip Hebrew/RTL marks and common separators that libphonenumber may choke on.
  raw = raw.replace(/[‎‏‪-‮]/g, '');
  if (raw.startsWith('00')) raw = '+' + raw.slice(2);
  // "972…" without plus is common when copied from WhatsApp links.
  if (/^972\d{8,9}$/.test(raw.replace(/\D/g, '')) && !raw.startsWith('+') && !raw.startsWith('0')) {
    raw = '+' + raw.replace(/\D/g, '');
  }
  const parsed = parsePhoneNumberFromString(raw, 'IL');
  if (!parsed || !parsed.isPossible()) return null;
  return parsed.number;
}

/** Israeli-style display: 052-631-6979 for Israeli numbers, international format otherwise. */
export function formatPhone(e164OrRaw: string | null | undefined): string {
  if (!e164OrRaw) return '';
  const parsed = parsePhoneNumberFromString(e164OrRaw, 'IL');
  if (!parsed) return e164OrRaw;
  if (parsed.country === 'IL' || parsed.countryCallingCode === '972') {
    const national = parsed.nationalNumber; // e.g. 526316979
    const d = '0' + national;
    if (d.length === 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`; // mobile 05X
    if (d.length === 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`; // landline 0X
    return d;
  }
  return parsed.formatInternational();
}

/** Digits-only form for wa.me links (no plus). */
export function whatsappLink(e164: string | null | undefined, text?: string): string | null {
  if (!e164) return null;
  const digits = e164.replace(/\D/g, '');
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${digits}${q}`;
}

export function isIsraeliMobile(e164: string | null | undefined): boolean {
  return !!e164 && /^\+9725\d{8}$/.test(e164);
}
